class CollectionInfiniteScroll {
  constructor(options = {}) {
    this.grid = document.querySelector(options.grid || "#ProductGrid");
    this.pagination = document.querySelector(options.pagination || "#Pagination");
    this.loader = document.querySelector(options.loader || "#CollectionLoader");

    this.loading = false;
    this.observer = null;

    this.init();
  }

  init() {
    this.observe();
    this.bindFilterEvents();
  }

  bindFilterEvents() {
    document.addEventListener("collection:updated", () => {
      this.grid = document.querySelector("#ProductGrid");
      this.pagination = document.querySelector("#Pagination");
      this.observe();
    });
  }

  observe() {
    if (!this.pagination) return;

    const next = this.pagination.dataset.next;
    if (!next) return;

    if (this.observer) this.observer.disconnect();

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.load(next);
          }
        });
      },
      {
        rootMargin: "500px",
      }
    );

    this.observer.observe(this.pagination);
  }

  async load(url) {
    if (this.loading) return;

    this.loading = true;
    this.loader?.classList.remove("hidden");

    try {
      const response = await fetch(url);
      const html = await response.text();

      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid = doc.querySelector("#ProductGrid");
      const newPagination = doc.querySelector("#Pagination");

      if (newGrid) {
        this.grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
      }

      if (newPagination && newPagination.dataset.next) {
        this.pagination.dataset.next = newPagination.dataset.next;
        this.observe();
      } else {
        this.observer.disconnect();
        this.pagination.remove();
      }

      if (window.Alpine) {
        Alpine.initTree(this.grid);
      }
    } catch (e) {
      console.error("Infinite Scroll Error", e);
    }

    this.loader?.classList.add("hidden");
    this.loading = false;
  }
}

window.CollectionInfiniteScroll = CollectionInfiniteScroll;

document.addEventListener("DOMContentLoaded", () => {
  new CollectionInfiniteScroll();
});